import { Result } from 'antd';

export default function NotFound() {
  return (
    <div className='flex flex-col justify-center flex-1'>
      <Result
        className=''
        status='404'
        title='Not found'
        subTitle='Page introuvable'
      />
    </div>
  );
}
